import * as types from '../mutation-types'

const state = {
	tempStorage: new Map()
}
// getters
const getters = {
  tempStorage: state => state.tempStorage
}
// actions
const actions = {
	saveItem ({ commit }, { key, value }) {
		if(!key) {
			return;
		}
		commit( types.SAVE_ITEM, { key, value } );
	},
	deleteItem ({ commit }, { key }) {
		if(!key) {
			return;
		}
		commit( types.DELETE_ITEM, { key } );
    },
	initialStorage ({ commit }) {
		commit( types.INITIAL_STROAGE );
	}
}
// mutations
const mutations = {
	// 保存一个item
	[types.SAVE_ITEM](state, { key, value } ) {
		state.tempStorage.set(key, value);
	},
	// 删除一个item
	[types.DELETE_ITEM](state, { key }) {
		state.tempStorage.delete(key);
	},
	// 初始化存储，清空所有存储
	[types.INITIAL_STROAGE](state) {
		state.tempStorage.clear();
	}
}
export default {
  state,
  getters,
  actions,
  mutations
}